import { ReferenceField, Show, SimpleShowLayout, TextField } from 'react-admin'

import { TASK_DICTIONARY } from '../../helpers/constants'
import Aside from '../Aside/aside'

const TaskTitle = ({ record }: any) => {
  return <span>Task: {record ? `${TASK_DICTIONARY[record.status_detail]}` : ''}</span>
}

const TaskShow = (props: any) => (
  <Show title={<TaskTitle />} aside={<Aside />} {...props}>
    <SimpleShowLayout>
      <ReferenceField source="id" reference="jobs" label="Job" link="show">
        <TextField source="human_id" />
      </ReferenceField>
      <TextField source="status_detail" />
      <TextField source="load.source" label="Broker name" />
      <TextField source="load.source_human_id" label="Broker reference #" />
      <ReferenceField source="assigned_to.id" reference="users" label="Driver" link="show">
        <TextField source="email" />
      </ReferenceField>
      <ReferenceField source="team.id" reference="teams" label="Team" link="show">
        <TextField source="name" />
      </ReferenceField>
    </SimpleShowLayout>
  </Show>
)

export default TaskShow
